import { create } from 'zustand';
import axiosInstance from '../../api/axiosInstance';


interface Blog {
    id: number;
    title: string;
    slug: string;
    image: string;
    teaser: string;
    description: string;
    createdAt: string;
    updatedAt?: string;
    meta_title?: string;
    meta_keyword?: string;
    meta_description?: string;
    schema?: string;
  }
  interface Field {
    type: string;
    value: string;
    link?: string;
  }
  interface Section {
    id: number;
    section_name: string;
    payload: Record<string, Field>;
  }
  
  interface BlogState {
    sections: Record<string, Section>;
    blogs: Blog[];
    relatedPosts: Blog[];
    selectedBlog?: Blog;
    fetchBlogs: () => void;
    fetchBlogById: (id: string) => void;
    fetchBlogContent: () => Promise<void>;
  }


  const useBlogStore = create<BlogState>((set) => ({
    sections: {},
    blogs: [],
    relatedPosts: [],
  selectedBlog: undefined,
  fetchBlogContent: async () => {
    try {
      const response = await axiosInstance.get("/cmsPages/blog");
      const formattedSections = response.data.pages.rows.reduce(
        (acc: Record<string, Section>, section: any) => {
          try {
            // Try to parse the payload
            const parsedPayload = JSON.parse(section.payload);
            acc[section.section_name] = {
              id: section.id,
              section_name: section.section_name,
              payload: parsedPayload,
            };
          } catch (parseError) {
            console.log(section.payload);
            console.error("Error parsing payload for section:", section.section_name, parseError);
          }
          return acc;
        },
        {}
      );

      set({ sections: formattedSections });
    } catch (error) {
      console.error("Error fetching home content:", error);
    }
  },
  fetchBlogs: async () => {
    try {
        const response = await axiosInstance('getBlogs');
        set({ blogs: response.data.rows });
      } catch (error) {
        console.error('Failed to fetch blogs:', error);
      }
  },
  fetchBlogById: async (slug: string) => {
   try {
            const response = await axiosInstance(`blogDetails/${slug}`);
            set({ selectedBlog: response.data.blog,relatedPosts: response.data.relatedPosts});
          } catch (error) {
            console.error('Failed to fetch blogs:', error);
          }
  },
 
}));
export default useBlogStore;